:host {
  --gap: #{space("small")};
  --sticky-padding-bottom: var(
    --stzh-sticky-actions-sticky-padding-bottom,
    #{space("small")}
  );

  --stuck-offset: calc(
    var(--stzh-pagetitle-disturber-stuck-height, 0px) +
      var(--stzh-sticky-cta-stuck-bottom-height, 0px)
  );

  @include mq($from: medium) {
    --sticky-padding-bottom: var(
      --stzh-sticky-actions-sticky-padding-bottom,
      #{space("medium")}
    );
  }

  @media print {
    display: none;
  }
}

.stzh-sticky-actions {
  &__container {
    display: flex;
    justify-content: flex-end;
    transition-property: transform;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__sticky {
    --padding-top: 0px;
    --padding-bottom: var(--sticky-padding-bottom);
  }

  &__sticky[is-stuck-bottom] &__container {
    transform: translateY(calc(var(--stuck-offset) / -1));
  }

  &__scrollup-wrapper {
    transition-property: transform, opacity, visibility;
    transition-duration: $baseTransitionAnimationSpeed;
    opacity: 0;
    visibility: hidden;
    transform: translateX(var(--stzh-sticky-actions-scrollup-width, 44px));
  }

  &.has-chat &__scrollup-wrapper {
    transform: translateX(
      calc((var(--stzh-sticky-actions-scrollup-width, 44px) + var(--gap)))
    );
  }

  &.has-scrollup &__chat-wrapper {
    transition-property: transform;
    transition-duration: $baseTransitionAnimationSpeed;
    transform: translateX(
      calc((var(--stzh-sticky-actions-scrollup-width, 44px)))
    );
  }

  /* Active scrollup variant */

  &.has-active-scrollup &__scrollup-wrapper {
    opacity: 1;
    visibility: visible;
    transform: translateX(0px);
  }

  &.has-active-scrollup &__chat-wrapper {
    transform: translateX(calc(var(--gap) / -1));
  }

  /* Is not slotted */
  &.is-not-slotted {
    height: 0;
  }
}
